import { useEffect, useState } from "react";

const BASE_STORAGE_KEY = "chatLastVisitTime";
const UPDATE_EVENT = "chat-last-visit-update";

const storageKey = (tournamentId?: number | null) =>
  tournamentId != null ? `${BASE_STORAGE_KEY}:tournament:${tournamentId}` : BASE_STORAGE_KEY;

const read = (tournamentId?: number | null): number => {
  const raw = localStorage.getItem(storageKey(tournamentId));
  const n = raw ? Number(raw) : 0;
  return Number.isFinite(n) ? n : 0;
};

export const markChatVisited = (time: number = Date.now(), tournamentId?: number | null) => {
  localStorage.setItem(storageKey(tournamentId), String(time));
  window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: { tournamentId: tournamentId ?? null } }));
};

export const useChatLastVisit = (tournamentId?: number | null): number => {
  const [value, setValue] = useState<number>(() => read(tournamentId));
  useEffect(() => {
    setValue(read(tournamentId));
    const handler = (e: Event) => {
      const customEvent = e as CustomEvent<{ tournamentId: number | null }>;
      // For storage event (cross-tab) we get no detail — just re-read; same for own events.
      const eventTournamentId = customEvent.detail?.tournamentId;
      if (eventTournamentId === undefined || eventTournamentId === (tournamentId ?? null)) {
        setValue(read(tournamentId));
      }
    };
    window.addEventListener(UPDATE_EVENT, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(UPDATE_EVENT, handler);
      window.removeEventListener("storage", handler);
    };
  }, [tournamentId]);
  return value;
};
